<script>
import { getSwitchTextbook, getTextbooksByPublisherIdAndSchoolStage } from '../../api/resource'
export default {
  name: 'SwitchTextbookDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    currentPublisher() {
      return this.publisherList.find(item => item.id === this.publisher_id)
    }
  },
  watch: {
    school_stage: {
      handler(val) {
        if (this.publisher_id) {
          this.initTextbookList()
        }
        if (val === 0 || this.publisherList.length > 0) return
        this.initPublisherList()
      },
      immediate: true
    },
    currentPublisher: {
      handler(val) {
        if (val && this.school_stage !== 0) {
          this.initTextbookList()
        }
      },
      deep: true
    }
  },
  data() {
    return {
      /** 0全部 1小学 2初中 3高中 */
      school_stage: 0,
      publisherList: [],
      publisher_id: null,
      textbookList: [],
      textbook_id: null,
      isFetchingTextbook: false,
    }
  },
  methods: {
    initPublisherList() {
      getSwitchTextbook().then(res => {
        this.publisherList = res.data
      })
    },
    initTextbookList() {
      this.isFetchingTextbook = true
      getTextbooksByPublisherIdAndSchoolStage({
        fb_publisher_id: this.publisher_id,
        school_stage: this.school_stage
      }).then(res => {
        this.textbookList = res.data
      }).finally(() => {
        this.isFetchingTextbook = false
      })
    },
    handleCancel() {
      this.show = false;
      this.school_stage = 0;
      this.publisher_id = null;
      this.textbook_id = null;
      this.textbookList = [];
      this.publisherList = [];
    },
    handleConfirm() {
      const textbook = this.textbookList.find(item => item.id === this.textbook_id)
      this.$emit('selectTextbook', textbook, this.currentPublisher, this.school_stage)
      this.show = false;
    },
  }
}
</script>

<template>
  <el-dialog width="600px" title="更换课件" :visible.sync="show" :destroy-on-close="true" :close-on-click-modal="false"
    v-bind="$attrs">
    <template #title>
      <div style="text-indent: 20px; font-size: 26px; padding: 16px 0;">
        更换课件
      </div>
    </template>
    <div class="row">
      <div class="label">学段：</div>
      <div class="content">
        <el-radio-group v-model="school_stage">
          <el-radio :label="1">小学</el-radio>
          <el-radio :label="2">初中</el-radio>
          <el-radio :label="3">高中</el-radio>
          <el-radio :label="0">全部</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="row" v-show="school_stage !== 0">
      <div class="label">出版社：</div>
      <el-select v-model="publisher_id" placeholder="选择出版社">
        <el-option v-for="item in publisherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="row" v-show="school_stage !== 0">
      <div class="label">课件：</div>
      <el-select v-model="textbook_id" placeholder="请先选择出版社" v-loading="isFetchingTextbook">
        <el-option v-for="item in textbookList" :key="item.id" :label="item.text_name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="bottom-footer">
      <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      <el-button class="confirm-btn" type="primary" @click="handleConfirm" :disabled="!textbook_id">确定</el-button>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
/deep/ .el-dialog__header {
  border-bottom: 1px solid #f0f0f0 !important;
}

/deep/ .el-dialog__header .el-dialog__title {
  font-size: 24px;
  text-indent: 30px;
}

// 解决 Element UI el-radio 组件的 aria-hidden 警告问题
/deep/ .el-radio__original {
  display: none !important;
}

/deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}

.row {
  display: flex;
  align-items: center;
  margin: 40px 0;

  .label {
    width: 150px;
    text-align: right;
    font-size: 24px;
    color: #5c5c5c;
    padding-right: 20px;
  }
}

.bottom-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;

  button {
    font-size: 24px;
    width: 160px;
    padding: 8px 20px;
  }
}
</style>
